<ng-select
	id="products"
	name="products"
	[(ngModel)]="productsToChange"
	[disabled]="editable"
	multiple="true"
	[closeOnSelect]="false"
	placeholder="Produkty"
	(change)="nightsAutocomplete()"
	matTooltip="Liczba w nawiasie oznacza liczbe obecnie wygenerowanych terminów"
>
	@for (item of groupProducts; track item.product) {
		<ng-option [value]="item"
			>{{ getProductName(item.product) + ' (' + item.termCount + ')' }}
			@if (item.nightStay !== null) {
				<span>- noclegów: {{ item.nightStay }} {{ item.isNightEvent ? '(nocny event)' : '' }}</span>
			}
			@if (item.nightStay === null) {
				<span>- noclegów: nieokreślona</span>
			}
		</ng-option>
	}
</ng-select>

<mat-form-field>
	<mat-label>Ilość noclegów</mat-label>
	<input
		[disabled]="editable"
		type="number"
		matInput
		name="name"
		[(ngModel)]="nightsStay"
		(change)="checkNightsStay()"
		step="1"
	/>
</mat-form-field>

<div *ngIf="nightsStay % 1 === 0 && nightsStay >= 0 && nightsStay !== null && productsToChange.length > 0">
	<div class="d-flex flex-column">
		<mat-radio-group
			[(ngModel)]="termsCreateType"
			aria-label="Select an option"
			color="primary"
			(change)="resetTerms()"
		>
			<mat-radio-button value="calendar" class="my-2 me-4">Kalendarz</mat-radio-button>
			<mat-radio-button value="logic" class="me-4">Logika zdarzeń</mat-radio-button>
			<mat-radio-button value="import">Import</mat-radio-button>
		</mat-radio-group>

		<mat-radio-group
			(change)="checkNightsStay()"
			[(ngModel)]="offerTermTransport"
			aria-label="Select an option"
			color="primary"
		>
			<mat-radio-button value="{{ OfferTermTransport.PLANE }}" class="my-2 me-4">Samolot</mat-radio-button>
			<mat-radio-button value="{{ OfferTermTransport.COACH }}" class="me-4">Autobus</mat-radio-button>
			<mat-radio-button value="{{ OfferTermTransport.BOTH }}">Oba</mat-radio-button>
		</mat-radio-group>
	</div>

	<div class="row mt-3">
		<div class="col" *ngIf="termsCreateType === 'calendar'">
			<mat-calendar [(selected)]="selected" (selectedChange)="updateTermsCalendar($event)"></mat-calendar>
		</div>
		<div class="col border-0" *ngIf="termsCreateType === 'import'">
			<mat-form-field>
				<mat-label>Dane</mat-label>
				<input type="text" matInput name="name" [(ngModel)]="importText" (change)="importTerms()" step="1" />
			</mat-form-field>
			<div class="alert alert-warning">
				<p class="fw-bold"><i class="me-2 fa-solid fa-circle-exclamation"></i>Obsługiwane formaty dat</p>
				RRRR-MM-DD -> np. 2022-01-21 <br />MM/DD/RRRR -> np. 01/21/2022
			</div>
		</div>
		<hr *ngIf="termsCreateType === 'logic'" />
		<div class="col border-0" *ngIf="termsCreateType === 'logic'">
			<mat-radio-group
				[(ngModel)]="termsCreateLogic"
				aria-label="Select an option"
				color="primary"
				(change)="resetTerms()"
			>
				<mat-radio-button value="from-to" class="my-2 me-4">Zaczyna się od-do</mat-radio-button>
				<mat-radio-button value="weeks">Co ile tygodni (liczba)</mat-radio-button>
			</mat-radio-group>
			<mat-form-field class="mt-2" *ngIf="termsCreateLogic === 'weeks'">
				<mat-label>Co ile tygodni</mat-label>
				<input type="number" matInput name="name" [(ngModel)]="weekDiff" (change)="resetTerms()" />
			</mat-form-field>
			<mat-form-field class="mt-2" *ngIf="termsCreateLogic === 'weeks'">
				<mat-label>Wybierz dzień tygodnia</mat-label>
				<mat-select [(ngModel)]="weekDay" (selectionChange)="resetTerms()">
					<mat-option *ngFor="let weekDay of dateService.weekDays" [value]="weekDay.value">
						{{ weekDay.name }}
					</mat-option>
				</mat-select>
			</mat-form-field>
			<mat-form-field class="mt-2">
				<mat-label>Zakres</mat-label>
				<mat-date-range-input [rangePicker]="picker">
					<input matStartDate matInput placeholder="Start date" [(ngModel)]="termsCreateRange.start" />
					<input
						matEndDate
						matInput
						placeholder="End date"
						[(ngModel)]="termsCreateRange.end"
						(dateChange)="updateTermsDateRange()"
					/>
				</mat-date-range-input>
				<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
				<mat-date-range-picker #picker></mat-date-range-picker>
			</mat-form-field>
		</div>
		<div class="col-8" *ngIf="termsCreateType !== null">
			<div id="termsToGenerate" class="p-2">
				<div id="termsContainer">
					<div *ngFor="let item of termsToGenerate" class="singleTerm p-2 d-flex align-items-center">
						@if (item.offerTerm === OfferTermTransport.COACH) {
							<i class="fas fa-bus d-flex align-items-center mx-2"></i>
						}
						@if (item.offerTerm === OfferTermTransport.PLANE) {
							<i class="fas fa-plane d-flex align-items-center mx-2"></i>
						}
						{{ item.dateRange.lower + ' - ' + item.dateRange.upper }}
						<i (click)="clearTerm(item)" class="far fa-times-circle d-flex align-items-center mx-2"></i>
					</div>
				</div>
				<div class="ms-auto" id="clearAllContainer" *ngIf="termsToGenerate.length > 0">
					<button
						mat-raised-button
						class="m-auto"
						color="primary"
						matTooltip="Wyczyść wszystkie"
						(click)="clearAllTerms()"
					>
						<i class="fa-regular fa-trash-can"></i>
					</button>
				</div>
			</div>
		</div>
	</div>
	<div class="footer">
		<button class="mx-4 my-auto" mat-raised-button color="primary" (click)="generateTerms()">
			<i class="fa-regular fa-pen-to-square"></i>
			Generuj
		</button>
	</div>
</div>
<div
	class="alert alert-warning"
	*ngIf="nightsStay % 1 !== 0 || nightsStay < 0 || nightsStay === null || productsToChange.length === 0"
>
	<p class="fw-bold"><i class="me-2 fa-solid fa-circle-exclamation"></i>Uwaga</p>
	Aby wygenerować terminy należy najpierw poprawnie uzupełnić liste produktów oraz ilość noclegów, tak aby wszystkie
	produkty miały tą samą liczbę noclegów.
</div>
